import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { SpinnerService } from '../spinner/spinner.service';

import { AuthActions } from './auth.actions';

@Injectable()
export class AuthSignupEffects {
  private readonly actions$ = inject(Actions);
  private readonly router = inject(Router);
  private readonly spinnerService = inject(SpinnerService);

  changeEmail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.changeEmail),
        tap(() => {
          // Navigate back to signup page when user wants to change email
          this.router.navigate(['/signup'], { replaceUrl: true }).then(() => {
            // Note: Adding a small delay because route initialization may restart spinners
            setTimeout(() => {
              this.spinnerService.stop();
            }, 500);
          });
        })
      ),
    { dispatch: false }
  );
}
